import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-touchscreen',
  templateUrl: './icon-touchscreen.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconTouchscreenComponent {}
